import useEventListener from '@use-it/event-listener';
import debounce from 'lodash.debounce';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import useConfiguration from '../../../hooks/useConfiguration';
import useSessionStorage from '../../../hooks/useSessionStorage';
import { logOut } from '../../Login/action';
import MessagesHeader from '../../MessagesHeader';
import UserNotificationModal from '../Modal/UserNotificationModal';
import {
  getLocationDistanceList,
  getLocationList,
  getUserNotifyList,
  saveUserNotifyList,
  setUserNotifyList,
  updateGlopalSearch,
} from './action';
import './header.css';
import JobFilter from './jobFilter';
import { headerInfoSelector } from './selector';
import { headerInfoSlice, resetGlopalSearch, resetHeaderSearch, setCurrentLocation, setHeaderState, setSearchText } from './slice';
import NotificationHeader from '../../NotificationHeader/NotificationHeader';
import * as Toasts from '../Toastify'
import InboxHeader from '../../Inbox/InboxHeader';
import TextNotificationHeader from '../../TextNotification/TextNotificationHeader';
import GpsHeader from '../../GpsIncident/GpsHeader';
import { FiAlertTriangle } from "react-icons/fi";
import newNotification from './newNotification.mp3'
import { getNotificationsData1 } from '../../NotificationHeader/action'



// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const [messagecount, setMessagecount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [inboxMessagesCount, setInboxMessagesCount] = useState(0);
  const [textNotificationsCount, setTextNotificationsCount] = useState(0);
  const [gpsIncidentCount, setGpsIncidentCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { userNotifyList, searchText, currentLocation,distance } = useSelector(headerInfoSelector);
  const locationMasterList = useSelector(store => store.headerInfo.locationMasterList);
  const locationDistanceList = useSelector(store => store.headerInfo.locationDistanceList);

  const config = useConfiguration();
  const storage = useSessionStorage();
  const dispatch = useDispatch();
  const login = storage.getItem('login');
  // const [searchText, setSearchText] = useState('');
  const [readOnly, setReadOnly] = useState(true);
  const [notificationData, setNotificationData] = useState({
    incidentData: [],
    smsData: [],
    inboxMailData: [],
    notificationData: [],
    uploadData: []
  });
  const [notificationsFlag, setNotificationsFlag] = useState({
    incidentFlag: false,
    smsFlag: false,
    inboxMailFlag: false,
    notificationFlag: false,
    uploadFlag: false
  });
  const [loader, setLoader] = useState(false);
  const debounceLoadData = useCallback(debounce(fetchData, 1000), []);
  const handleKeyEvent = ({ key }) => {
    // if (key === "Enter" || key === 13) {
    //     navigate('/joblist');
    // }
  };
  useEventListener('keydown', handleKeyEvent);
  const gotoProfilePage = (event) => {
    event.preventDefault();
    navigate('/employerProfile');
  };
  const logout = (event) => {
    event.preventDefault();
    storage.setItem('login', null);
    storage.setItem('userNotification', false);
    dispatch(logOut()).then(() => {
      navigate('/');
      window.location.reload();
    });
  };
  const gotoUpdatePassword = (event) => {
    event.preventDefault();
    navigate('/updatepassword');
  };

  useEffect(() => {
    const userNotification = storage.getItem('userNotification') || false;
    if (config.baseUrl && !userNotification) {
      dispatch(
        getUserNotifyList(config.baseUrl, {
          appuserUniqueId: login.appUserUniqueId,
        })
      );
      storage.setItem('userNotification', true);
    }
    if(config.baseUrl && locationMasterList?.length === 0){
      dispatch(getLocationList({baseUrl:config.baseUrl, empID:login.employerUniqueId}))
    }
    if(config.baseUrl && locationDistanceList?.length === 0){
      dispatch(getLocationDistanceList({baseUrl:config.baseUrl, employerId:login.employerId, employerUniqueId:login.employerUniqueId}))
    }
  }, [config]);



  // useEffect(() => {
  //   if (searchText) {
  //     debounceLoadData(searchText);
  //   } else {
  //     dispatch(updateGlopalSearch(searchText));
  //   }
  // }, [searchText]);

  const updateVal = (target) => {
    dispatch(setSearchText(target.value))
  };
  const getmessagecount = (count) => {
    setMessagecount(count);
  };
  const getNotificationCount = (count) => {
    setNotificationCount(count);
  };
  const getInboxMessagesCount = (count) => {
    setInboxMessagesCount(count);
  };
  const getGpsincidentCount = (count) => {
    const incidentCount = localStorage.getItem('incidentCount');
    if (count > +incidentCount) {
      const audio = new Audio(newNotification);
      audio?.load();
      audio?.play()
    }
    localStorage.setItem('incidentCount', count);
    setGpsIncidentCount(count);
  };

  const getTextNotificationsCount = (count) => {
    setTextNotificationsCount(count);
  };
  function fetchData(search, locationValue,distance) {
    if (location.pathname !== '/newcandidatesearchv2') {
      navigate('/newcandidatesearchv2', {
        state: {
          searchText: search,
          locationValueId: locationValue,
          defaultDistance: distance,
          isSearchWithCriteria:true
        },
      });
      if (search && locationValue) {
        dispatch(resetHeaderSearch());
        dispatch(resetGlopalSearch());
      }
    } else {
      dispatch(updateGlopalSearch(search, locationValue, distance));
    }
  }

  const handleUserNotificationClose = (id) => {
    let notifyValue = userNotifyList.notifiyList.find(
      (value) => value.featuresNotifyId === id
    );
    notifyValue = { ...notifyValue, isActive: false };

    const data = {
      ...userNotifyList,
      notifiyList: [
        ...userNotifyList.notifiyList.filter(
          (value) => value.featuresNotifyId !== id
        ),
        notifyValue,
      ],
    };
    dispatch(setUserNotifyList(data));
  };

  const handleUserNotificationSave = (id) => {
    dispatch(
      saveUserNotifyList(config.baseUrl, {
        appuserUniqueId: `${login.appUserUniqueId}`,
        featuresNotifyId: id,
      })
    );
    handleUserNotificationClose(id);
  };

  // const downloadUploadDoc = (filename, docId) => {
  //   // dispatch(downloadEmpDocument(config.baseUrl, docId))
  //   fetch(`${config.baseUrl}/Notify/download-notify-document?featuresNotifyAttachmentId=${docId}`)
  //     .then(response => {
  //       if (response) {
  //         response.blob().then(blob => {
  //           let url = window.URL.createObjectURL(blob);
  //           let a = document.createElement('a');
  //           a.href = url;
  //           a.download = filename;
  //           a.click();
  //         });
  //       }
  //     });
  // }

  const downloadUploadDoc = async (filename, docId) => {
    try {
        const response = await fetch(`${config.baseUrl}/Notify/download-notify-document?featuresNotifyAttachmentId=${docId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${login.accessToken}`,
            },
        });

        if (response.ok) {
            const blob = await response.blob();

            console.log('Blob Size:', blob.size);
            console.log('Blob Type:', blob.type);

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            // Extract filename from Content-Disposition header if available
            const contentDisposition = response.headers.get('Content-Disposition');
            const suggestedFilename = contentDisposition ? contentDisposition.split('filename=')[1] : null;
    
            // Use the provided filename or suggested filename
            a.download = filename || suggestedFilename || 'downloaded-file';

            // Trigger download
            a.click();
        } else {
            console.error('Server returned an error:', response.status, response.statusText);
        }
    } catch (error) {
        console.error('Error during file download:', error);
    }
};

  const locationList = JSON.parse(sessionStorage.getItem('locationList'));
  // const [currentLocation,setCurrentLocation] = useState("")
  const updateDropVal = (target) => {
    const { name, value } = target;
    if(locationDistanceList?.length){
      const locationInfo = locationDistanceList?.find(location => location?.locationId?.toString() === value?.toString());
      dispatch(setHeaderState({name:"distance",value:locationInfo?.acceptableTravelDistance?.toString()}));
    }
    dispatch(setCurrentLocation(value));
  };
  const searchHandler = e => {
    e.preventDefault();
    if (currentLocation && searchText) {
      fetchData(searchText, currentLocation,distance)
    } else {
      if (!currentLocation && !searchText) {
        Toasts.error("Please select Location and enter search keyword ")
      }
      else if (!currentLocation) {
        Toasts.error("Please select Location ")
      } else if (!searchText) {
        Toasts.error("Please enter search keyword ")
      }

    }
  }

  const hideHeaderNotification = pageName => {
    setNotificationsFlag({
      incidentFlag: false,
      smsFlag: false,
      inboxMailFlag: false,
      notificationFlag: false,
      uploadFlag: false
    })
  }

  const getNotificationValue = async (name, flag) => {
    const defaultValue = {
      incidentData: [],
      smsData: [],
      inboxMailData: [],
      notificationData: [],
      uploadCount: []
    }
    const data = await getNotificationsData1(`${config.baseUrl}/Messaging/get-employer-notify-messages?message=${flag}`);
    //console.log(data, '--------->');
    if (data && data?.shortMessages) {
      setNotificationData({
        ...defaultValue,
        [name]: data?.shortMessages
      })
    }
    setLoader(false);
  }

  // console.log(notificationData);

  return (
    <>
      <ToastContainer style={{ 'zIndex': 99999 }} />
      {!!userNotifyList &&
        !!userNotifyList.notifiyList &&
        userNotifyList.notifiyList
          .filter((value) => value.isActive === true)
          .reverse()
          .map((value) => {
            return (
              <UserNotificationModal
                showModal={true}
                htmlData={value.messageHtmlText}
                headerText={value.headerText}
                id={value.featuresNotifyId}
                files={value?.notifyAttachmentsList}
                handleUserNotificationClose={handleUserNotificationClose}
                handleUserNotificationSave={handleUserNotificationSave}
                downloadFile={downloadUploadDoc}
              />
            );
          })}
      <div className="app-header header sticky app-header-margin">
        <div className="container-fluid main-container">
          <div className="d-flex">
            <a
              aria-label="Hide Sidebar"
              className="app-sidebar__toggle"
              data-bs-toggle="sidebar"
              href="#"
            ></a>
            <a className="logo-horizontal" href="MyDashboard">
              <img
                src="/assets/images/brand/logo.png"
                className="header-brand-img light-logo"
                alt="logo"
              />
              <img
                src="/assets/images/brand/Overturecommonlogo.svg"
                className="header-brand-img light-logo"
                alt="logo"
              />
            </a>
            <div style={{ columnGap: "1rem" }} className="  d-none d-lg-flex align-items-center">
              <select
                className="form-select"
                value={currentLocation}
                name="locationId"
                onChange={(e) => {
                  updateDropVal(e.target);
                }}
              >
                <option disabled={true} hidden={true} value={""}>Location Name *</option>
                {locationMasterList?.length && locationMasterList.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <div className='main-header-center ms-3'>
                <input
                  style={{ width: "250px", paddingRight: "2rem" }}
                  className="form-control"
                  placeholder="First name, Last name, Email *"
                  name="searchtext"
                  onChange={(e) => {
                    updateVal(e.target);
                  }}
                  value={searchText}
                  readOnly={readOnly}
                  onFocus={() => setReadOnly(false)}
                  onBlur={() => setReadOnly(true)}
                  type="text"
                />

                <button onClick={e => searchHandler(e)} className="btn px-0 pt-2">
                  <i className="fe fe-search" aria-hidden="true"></i>
                </button>
              </div>


            </div>

            {/* { <JobFilter />  } */}
            <div className="d-flex order-lg-2 ms-auto header-right-icons">
              <button
                className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent-4"
                aria-controls="navbarSupportedContent-4"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon fe fe-more-vertical"></span>
              </button>
              <div className="navbar navbar-collapse responsive-navbar p-0">
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent-4"
                >
                  <div className="d-flex order-lg-2 align-items-center">
                    {/* text notification */}
                    {/* <div className="dropdown  d-flex message">
                      {textNotificationsCount !== 0 && (
                        <span
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {textNotificationsCount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                        data-bs-toggle="dropdown"
                      >
                        <i
                          class="fa fa-file-text-o"
                          style={{ fontSize: '26px', cursor: "pointer" }}
                        ></i>
                        {textNotificationsCount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px' }}
                          ></span>
                        )}
                      </a>
                      <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <TextNotificationHeader
                          getTextNotificationsCount={getTextNotificationsCount}
                        ></TextNotificationHeader>
                      </div>
                    </div> */}
                    {/* Gps Incident */}
                    <div style={{ position: 'relative' }} className="  d-flex message">
                      {gpsIncidentCount !== 0 && (
                        <span
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {gpsIncidentCount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                        onClick={() => {
                          setNotificationsFlag({
                            incidentFlag: !notificationsFlag.incidentFlag,
                            smsFlag: false,
                            inboxMailFlag: false,
                            notificationFlag: false,
                            uploadFlag: false
                          })
                          setLoader(true);
                          getNotificationValue('incidentData', 1)
                        }}
                      >
                        <FiAlertTriangle size={34} color="#e82646" />
                        {gpsIncidentCount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px', right: '5px' }}
                          ></span>
                        )}
                      </a>
                      <div style={{ position: "absolute", left: "-15rem", width: "19rem" }} className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow   ${notificationsFlag.incidentFlag && 'show'}`}>
                      <div className='position-relative'>
                        <GpsHeader
                          getGpsIncidentCount={getGpsincidentCount}
                          hideHeaderNotification={hideHeaderNotification}
                          data={notificationData.incidentData}
                          loader={loader}
                          updateNotificationFlag = {setNotificationsFlag}
                        ></GpsHeader>
                      </div>
                      </div>
                    </div>
                    {/* TextNotification => SMS */}
                    <div style={{ position: 'relative' }} className="  d-flex message">
                      {textNotificationsCount !== 0 && (
                        <span
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {textNotificationsCount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                        onClick={() => {
                          setNotificationsFlag({
                            incidentFlag: false,
                            smsFlag: !notificationsFlag.smsFlag,
                            inboxMailFlag: false,
                            notificationFlag: false,
                            uploadFlag: false
                          })
                          setLoader(true);
                          getNotificationValue('smsData', 2)
                        }}
                      >

                        <span className='connection'>
                          <i
                            class="fa fa fa-commenting-o"
                            style={{ fontSize: '24px', cursor: "pointer", color: "#fff" }}
                          ></i>
                        </span>
                        {textNotificationsCount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px', right: '5px' }}
                          ></span>
                        )}
                      </a>
                      <div style={{ position: "absolute", left: "-15rem", width: "19rem" }} className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow   ${notificationsFlag.smsFlag && 'show'}`}>
                      <div className='position-relative'>
                        <TextNotificationHeader
                          getTextNotificationsCount={getTextNotificationsCount}
                          hideHeaderNotification={hideHeaderNotification}
                          data={notificationData.smsData}
                          loader={loader}
                          updateNotificationFlag = {setNotificationsFlag}
                        ></TextNotificationHeader>
                      </div>
                      </div>
                    </div>
                    {/* Email */}
                    <div style={{ position: 'relative' }} className="  d-flex message">
                      {inboxMessagesCount !== 0 && (
                        <span
                          style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {inboxMessagesCount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                        onClick={() => {
                          setNotificationsFlag({
                            incidentFlag: false,
                            smsFlag: false,
                            inboxMailFlag: !notificationsFlag.inboxMailFlag,
                            notificationFlag: false,
                            uploadFlag: false
                          })
                          setLoader(true);
                          getNotificationValue('inboxMailData', 3)
                        }}
                      >

                        <span className='connection'>
                          <i
                            class="ti-email"
                            style={{ fontSize: '24px', cursor: "pointer", color: "#fff" }}
                          ></i>
                        </span>
                        {inboxMessagesCount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px', right: '5px' }}
                          ></span>
                        )}
                      </a>
                      <div style={{ position: "absolute", left: "-15rem", width: "19rem" }} className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow   ${notificationsFlag.inboxMailFlag && 'show'}`}>
                        <div className='position-relative'>
                        <InboxHeader
                          getInboxMessagesCount={getInboxMessagesCount}
                          hideHeaderNotification={hideHeaderNotification}
                          data={notificationData.inboxMailData}
                          loader={loader}
                          updateNotificationFlag = {setNotificationsFlag}
                        ></InboxHeader>
                        </div>
                      </div>
                    </div>
                    <div style={{ position: 'relative' }} className="  d-flex message">
                      {messagecount !== 0 && (
                        <span
                          style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {messagecount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                      >
                        <i
                          onClick={() => {
                            setNotificationsFlag({
                              incidentFlag: false,
                              smsFlag: false,
                              inboxMailFlag: false,
                              notificationFlag: !notificationsFlag.notificationFlag,
                              uploadFlag: false
                            })
                            setLoader(true);
                            getNotificationValue('notificationData', 4)
                          }}
                          className="fa fa-solid fa-bell"
                          style={{ fontSize: '30px' }}
                        ></i>
                        {messagecount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px' }}
                          ></span>
                        )}
                      </a>
                      <div style={{ position: "absolute", left: "-15rem", width: "19rem" }} className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow   ${notificationsFlag.notificationFlag && 'show'}`}>
                      <div className='position-relative'>
                        <MessagesHeader
                          getmessagecount={getmessagecount}
                          hideHeaderNotification={hideHeaderNotification}
                          data={notificationData.notificationData}
                          loader={loader}
                          updateNotificationFlag = {setNotificationsFlag}
                        ></MessagesHeader>
                      </div>
                      </div>
                    </div>
                    {/* notification */}
                    <div style={{ position: 'relative' }} className="  d-flex message">
                      {notificationCount !== 0 && (
                        <span
                          style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            margin: '0px -12px 0px 0px',
                            padding: '20px 0px 0px 2px',
                          }}
                        >
                          {notificationCount}
                        </span>
                      )}
                      <a
                        className="nav-link icon text-center"
                        onClick={() => {
                          setNotificationsFlag({
                            incidentFlag: false,
                            smsFlag: false,
                            inboxMailFlag: false,
                            notificationFlag: false,
                            uploadFlag: !notificationsFlag.uploadFlag
                          })
                          setLoader(true);
                          getNotificationValue('uploadData', 5)
                        }}
                      >
                        <i
                          className="fa fa-arrow-circle-up"
                          style={{ fontSize: '30px', cursor: "pointer" }}
                        ></i>
                        {notificationCount !== 0 && (
                          <span
                            className="pulse-danger"
                            style={{ fontSize: '12px' }}
                          ></span>
                        )}
                      </a>
                      <div style={{ position: "absolute", left: "-15rem", width: "19rem" }} className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow   ${notificationsFlag.uploadFlag && 'show'}`}>
                      <div className='position-relative'>
                        <NotificationHeader
                          getNotificationCount={getNotificationCount}
                          hideHeaderNotification={hideHeaderNotification}
                          data={notificationData.uploadData}
                          loader={loader}
                          updateNotificationFlag = {setNotificationsFlag}
                        ></NotificationHeader>
                      </div>
                      </div>
                    </div>
                    {/* profile part old code */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="jumps-prevent jumps-prevent-padding main-background"></div>
    </>
  );
};
